import PropTypes from "prop-types";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
import { toast } from "react-toastify"; // Assuming you use react-toastify for notifications
import {
  GetCustomSettingTemplate,
  UpdateCustomSettingTemplate,
} from "../service/authApi";
import React, { useEffect, useState } from "react";
import RichTextEditor from "react-rte";

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`vertical-tabpanel-${index}`}
      aria-labelledby={`vertical-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 6 }}>{children}</Box>}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `vertical-tab-${index}`,
    "aria-controls": `vertical-tabpanel-${index}`,
  };
}

export default function VerticalTabs() {
  const [tabValue, setTabValue] = useState(0);
  const [banner, setBannerText] = useState(RichTextEditor.createEmptyValue());
  const [templateID, setTemplateId] = useState(null);
  const [thankYouJobCreation, setJobConfigThanksText] = useState(
    RichTextEditor.createEmptyValue()
  );

  const [thankYouAddUser, setAddUserThanksText] = useState(
    RichTextEditor.createEmptyValue()
  );
  const [welcomeSignUp, setWelcome] = useState(
    RichTextEditor.createEmptyValue()
  );
  const [thankyouForJobNote, setNote] = useState(
    RichTextEditor.createEmptyValue()
  );
  const [termsCondition, settermsCondition] = useState(
    RichTextEditor.createEmptyValue()
  );

  const handleChange = (event, newValue) => {
    setTabValue(newValue);
  };

  const handleEditorChange = (setter) => (value) => {
    setter(value);
  };
  const refreshData = async () => {
    try {
      const response = await GetCustomSettingTemplate();
      setTemplateId(response?.data.templateId);
      if (response.status) {
        const data = response.data;
        setBannerText(
          RichTextEditor.createValueFromString(data.banner || "", "html")
        );
        setJobConfigThanksText(
          RichTextEditor.createValueFromString(
            data.thankYouJobCreation || "",
            "html"
          )
        );
        setAddUserThanksText(
          RichTextEditor.createValueFromString(
            data.thankYouAddUser || "",
            "html"
          )
        );
        setNote(
          RichTextEditor.createValueFromString(
            data.thankyouForJobNote || "",
            "html"
          )
        );
        setWelcome(
          RichTextEditor.createValueFromString(data.welcomeSignUp || "", "html")
        );
        settermsCondition(
          RichTextEditor.createValueFromString(
            data.termsCondition || "",
            "html"
          )
        );
      } else {
        toast.error(response.message || "Failed to load settings");
      }
    } catch (error) {
      toast.error("Failed to load latest settings");
      console.error("Error loading settings:", error);
    }
  };
  const handleSave = async (updateEntity, data) => {
    try {
      await UpdateCustomSettingTemplate(
        updateEntity,
        data.toString("html"),
        templateID
      );
      toast.success(`Text is updated successfully`);
      await refreshData();
    } catch (error) {
      toast.error(`Failed to update ${updateEntity}`);
      console.error(error);
    }
  };

  const toolbarConfig = {
    display: [
      "INLINE_STYLE_BUTTONS",
      "BLOCK_TYPE_BUTTONS",
      "LINK_BUTTONS",
      "BLOCK_TYPE_DROPDOWN",
      "HISTORY_BUTTONS",
    ],
    INLINE_STYLE_BUTTONS: [
      { label: "Bold", style: "BOLD", className: "custom-css-class" },
      { label: "Italic", style: "ITALIC" },
      { label: "Underline", style: "UNDERLINE" },
    ],
    BLOCK_TYPE_DROPDOWN: [
      { label: "Normal", style: "unstyled" },
      { label: "Heading Large", style: "header-one" },
      { label: "Heading Medium", style: "header-two" },
      { label: "Heading Small", style: "header-three" },
    ],
    BLOCK_TYPE_BUTTONS: [
      { label: "UL", style: "unordered-list-item" },
      { label: "OL", style: "ordered-list-item" },
    ],
  };

  useEffect(() => {
    refreshData();
  }, []);

  return (
    <Box sx={{ bgcolor: "background.paper" }}>
      <Tabs
        orientation="horizontal"
        variant="scrollable"
        value={tabValue}
        onChange={handleChange}
        aria-label="Vertical tabs example"
        sx={{ borderBottom: 1, borderColor: "divider" }}
      >
        <Tab label="Banner Text" {...a11yProps(0)} />
        <Tab label="Job Configuration Thanks Modal" {...a11yProps(1)} />
        <Tab label="Add User Thanks Modal" {...a11yProps(2)} />
        <Tab label="Welcome Modal " {...a11yProps(3)} />
        <Tab label="Modal Note" {...a11yProps(4)} />
        <Tab label="Terms and Condition" {...a11yProps(5)} />
      </Tabs>

      <TabPanel value={tabValue} index={0}>
        <RichTextEditor
          value={banner}
          onChange={handleEditorChange(setBannerText)}
          toolbarConfig={toolbarConfig}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            className="customizationSubmit"
            onClick={() => handleSave("banner", banner)}
          >
            UPDATE
          </Button>
        </Box>
      </TabPanel>

      <TabPanel value={tabValue} index={1}>
        <RichTextEditor
          value={thankYouJobCreation}
          onChange={handleEditorChange(setJobConfigThanksText)}
          toolbarConfig={toolbarConfig}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            className="customizationSubmit"
            onClick={() =>
              handleSave("thankYouJobCreation", thankYouJobCreation)
            }
          >
            UPDATE
          </Button>
        </Box>
      </TabPanel>

      <TabPanel value={tabValue} index={2}>
        <RichTextEditor
          value={thankYouAddUser}
          onChange={handleEditorChange(setAddUserThanksText)}
          toolbarConfig={toolbarConfig}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            className="customizationSubmit"
            onClick={() => handleSave("thankYouAddUser", thankYouAddUser)}
          >
            UPDATE
          </Button>
        </Box>
      </TabPanel>
      <TabPanel value={tabValue} index={3}>
        <RichTextEditor
          value={welcomeSignUp}
          onChange={handleEditorChange(setWelcome)}
          toolbarConfig={toolbarConfig}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            className="customizationSubmit"
            onClick={() => handleSave("welcomeSignUp", welcomeSignUp)}
          >
            UPDATE
          </Button>
        </Box>
      </TabPanel>

      <TabPanel value={tabValue} index={4}>
        <RichTextEditor
          value={thankyouForJobNote}
          onChange={handleEditorChange(setNote)}
          toolbarConfig={toolbarConfig}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            className="customizationSubmit"
            onClick={() => handleSave("thankyouForJobNote", thankyouForJobNote)}
          >
            UPDATE
          </Button>
        </Box>
      </TabPanel>

      <TabPanel value={tabValue} index={5}>
        <RichTextEditor
          value={termsCondition}
          onChange={handleEditorChange(settermsCondition)}
          toolbarConfig={toolbarConfig}
        />
        <Box mt={2}>
          <Button
            variant="contained"
            className="customizationSubmit"
            onClick={() => handleSave("termsCondition", termsCondition)}
          >
            UPDATE
          </Button>
        </Box>
      </TabPanel>
    </Box>
  );
}

VerticalTabs.propTypes = {
  onChange: PropTypes.func,
};
